import React from 'react';
import styled from 'styled-components';
import Styles from '../CartItem/CartItem.styles';
import Text from '../Text';
import editIcon from '../../compound/TicketsWhite/Assets/ico_edit.svg';
import deleteIcon from '../../compound/TicketsWhite/Assets/ico_delete.svg';
import shuttlePurpleIcon from '../../../assets/images/Shuttle/CBX_purpleShuttle.svg';

const Container = styled.div`${Styles.cartTicketsListItem}`;
const Icon = styled.img`${Styles.cartTicketsListItemIcon}`;
const InfoWrapper = styled.div`${Styles.cartTicketsListItemInfoWrapper}`;
const Product = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.cartTicketsListItemProduct}`;
const ActionIcon = styled.img`${Styles.cartTicketsListItemDelete}`;
const Label = styled(Text).attrs({ bold: true })`${Styles.cartTicketsListItemInfoLabel}`;
const InfoText = styled(Text)`${Styles.cartTicketsListItemInfoText}`;
const Row = styled.div`${Styles.cartTicketsListItemInfoRow}`;
const Column = styled.div`${Styles.cartTicketsListItemInfoCol}`;
// eslint-disable-next-line require-jsdoc

const CartItemShuttle = ({
  product,
  index,
  locale,
  editFn,
  deleteFn
}) => {
  let editBtn = <></>;
  if(editFn) {
    editBtn = <ActionIcon
    onClick={() => {
      editFn(index);
      window.localStorage.setItem('currentFlow', 'Ticket');
    }}
    src={editIcon}
    style={{ marginRight: 10 }}/>
  }
  let deleteBtn = <></>;
  if(deleteFn) {
    deleteBtn = <ActionIcon
    onClick={() => {
      deleteFn(index);
    }}
    src={deleteIcon}/>
  }

  let Item = <></>;
  const shuttleAmount = parseInt(product.passengersQ, 10) * product.price;
  let baggageAmount = 0.0;
  if (product.totalExtraBaggages) {
    baggageAmount = product.totalExtraBaggagesCharges;
  }
  const totalAmount = shuttleAmount + baggageAmount;
  Item = (
    <Container>
      <Icon src={shuttlePurpleIcon} />
      <InfoWrapper>
        <Row style={{ justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Product style={{ flex: 4, display: 'grid' }}>{`${product.passengersQ} ${locale === 'es' ? 'boleto' : 'ticket'}${product.passengersQ > 1 ? 's' : ''} Shuttle`}
            <InfoText>{`${product.passengersQ} ${locale === 'es' ? 'pasajeros' : 'passengers'} ${product.typeId === 1 ? locale == 'es' ? 'Sencillo' : 'One way' : locale === 'es' ? 'Redondo' : 'Round trip'}`}</InfoText>
            {false && product.totalExtraBaggages && <InfoText>{` ${product.totalExtraBaggages} ${locale == 'es' ? 'Maletas Extra' : 'Extra Baggages'}`}</InfoText>}
          </Product>
          <Product style={{ flex: 1, textAlign: 'end', flexDirection: 'column' }}>
            {!product.Discount && (<>
              <span>{`$${totalAmount.toFixed(2)}`}&nbsp;USD</span>
              <InfoText>{`$${shuttleAmount.toFixed(2)}`}&nbsp;USD</InfoText>
              </>
            )
            }
            {!!product.Discount && (<>
              <span style={{ textDecoration: 'line-through', color: '#666' }}>{`$${totalAmount.toFixed(2)}`}&nbsp;USD</span>
              <span> {`$${(totalAmount - product.Discount).toFixed(2)}`}&nbsp;USD</span></>
            )
            }

            {false && product.totalExtraBaggages && <InfoText>${baggageAmount.toFixed(2)} USD</InfoText>}
          </Product>
        </Row>
        <Row>
          <Column style={{ flex: 2 }}>
            <Row style={{ alignItems: 'flex-start' }}>
              <Label>{`${locale === 'es' ? 'Salida' : 'Departure'}: `}</Label>
              <InfoText>{` ${product.originText}`}</InfoText>
            </Row>
            <Row style={{ alignItems: 'flex-start', flex: 1, marginRight: 35 }}>
              <Label>{`${locale === 'es' ? 'Inicio' : 'Start'}: `}</Label>
              <InfoText>{`${product.departureDateTime.replace('T', ' @ ').substring(0, 18)}`}</InfoText>
            </Row>
          </Column>
          <Column style={{ flex: 2 }}>
            <Row style={{ alignItems: 'flex-end' }}>
              <Label>{`${locale === 'es' ? 'Llegada' : 'Arrival'}: `}</Label>
              <InfoText>{` ${product.destinationText}`}</InfoText>
            </Row>
            {product.typeId && (
              <Row style={{ alignItems: 'flex-start' }}>
                <Label>{`${locale === 'es' ? 'Fin' : 'End'}: `}</Label>
                <InfoText>{` ${product.arrivalDateTime.replace('T', ' @ ').substring(0, 18)}`}</InfoText>
              </Row>
            )}
          </Column>
          <Column style={{ flex: product.departureDate ? 1 : 2, marginRight: 0 }}>
            <Row style={{ justifyContent: 'end' }}>
            {editBtn}
            {deleteBtn}
            </Row>
          </Column>
        </Row>
      </InfoWrapper>
    </Container>
  );
  return Item;
};

export default CartItemShuttle;
